import { stylesheet } from 'typestyle';
import { Gray100, typeCompact14RegularProperties } from '@traceair/tds';
import React from 'react';
import { MissionWindowPanoramaLocation } from './MissionWindowPanoramaLocation';

const css = stylesheet({
  heading: {
    ...typeCompact14RegularProperties,
    color: Gray100,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: 0,
    margin: 0,
    listStyle: 'none',
  },
  location: {
    margin: '6px -10px 0 0',
    lineHeight: 1.5,
  },
});

interface Props {
  panoramaLocations?: string[];
}

export const MissionWindowPanoramaLocations = ({ panoramaLocations }: Props) => {
  if (!panoramaLocations?.length) {
    return <div className={css.heading}>Not available</div>;
  }

  return (
    <ul className={css.list}>
      {panoramaLocations.map((line, index) => {
        if (!line.trim()) return;

        return (
          <li key={index}>
            <div className={css.heading}>Location {index + 1}</div>

            <div className={css.location}>
              <MissionWindowPanoramaLocation location={line} />
            </div>
          </li>
        );
      })}
    </ul>
  );
};
